<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="jps-modal"
      dialog-width="20vw"
      dialog-height="40vh"
      dialog-min-width="40rem"
      dialog-min-height="28rem"
    >
      <template #header>
        <BaseIcon name="mdi/web" />
        {{ lss('オンライン設定', 'Online config') }}
      </template>
      <div class="jps-modal-content">
        <form @submit.prevent="ok()">
          <ValidationForm :rule="rule" :target="conf" @valid="(v) => allValid = v" />
          <button style="display: none" type="submit"></button>
        </form>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
        <button @click="ok()" :disabled="!allValid">{{ lss('開始', 'Start') }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import type { BaseModal } from '#components'
import { dapLangGlobal } from '#imports'

const { ls, lss } = useI18n()
const conf: Ref<ConfType> = ref()

const modal = ref<InstanceType<typeof BaseModal>>()
const openAwait = async () => {
  conf.value = {
    name: props.workspace.name,
    description: props.workspace.description,
    keyHash: '',
    user: '',
    color: '#' + randomColor(),
  }
  valid.value = false
  return await modal.value.openAwait<ConfType>()
}
defineExpose({ openAwait })

interface Props {
  workspace: WorkspaceEntry
}
const props = withDefaults(defineProps<Props>(), {})

type ConfType = {
  name: string,
  description: string,
  keyHash: string,
  user: string,
  color: string,
}
const rule: ValidationRule = {
  fields: {
    name: {
      field: 'name',
      type: 'string',
      mandatory: true,
      label: {
        ja: 'ギャラリー名',
        en: 'Gallery title',
      },
    },
    description: {
      field: 'description',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'ギャラリーの説明',
        en: 'Gallery description',
      },
    },
    keyHash: {
      field: 'keyHash',
      type: 'string',
      mandatory: true,
      strPattern: '[!-~]{4,}',
      label: {
        ja: 'アクセスパスワード',
        en: 'Access Password',
      },
      inputHelp: {
        ja: 'アルファベット・数字・記号4文字以上',
        en: 'At least 4 characters (letters, numbers, or symbols)',
      },
      description: {
        ja: '他のユーザがこのオンラインギャラリーにアクセスするためのパスワードです。アルファベット・数字・記号で4文字以上にしてください。',
        en: 'Set a password for other users to access this gallery. Use at least 4 characters (letters, numbers, or symbols).',
      },
    },
  },
}

const valid:Ref<boolean> = ref(false)
const allValid = computed({
  get: () => valid.value,
  set: (v) => valid.value = v,
})

const ok = () => {
  if (allValid.value) {
    modal.value.resolve(conf.value)
  }
}
</script>
